import React, { useState } from "react";
import { Row, Col, Form, Table, Button } from "react-bootstrap";
import moment from "moment";
import helpers from "../../utils/helpers";
import obj, { headerData, headerDataBetHistory } from "../../utils/constants";
import { toast } from "wc-toast";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import ReactPaginate from "react-paginate";
import Loader from "../../assets/gif/loader.gif";
import { capitalize, startCase } from "lodash";
import PaginationComp from "../../components/PaginationComp";
import DatePicker from "react-datepicker";
const ExchangeHistory = ({
  title,
  filter,
  setFilter,
  data,
  getData,
  viewpage,
  handlePageClick,
  pageCount,
  isLoader,
}) => {
  const [active, setActive] = useState([]);

  return (
    <div className="common-container">
      <Form className="bet_status mb-3">
        <Row>
          <Col xl={11} md={12}>
            <Row>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="d-flex align-items-center betting-time-zone">
                  <Form.Label className="pe-3">Period</Form.Label>
                  <div className="d-flex align-items-center">
                  <DatePicker
                                className="small_form_control"
                                selected={
                                  filter.fromPeriod
                                    ? new Date(filter.fromPeriod)
                                    : null
                                }
                                onChange={(date) =>
                                  setFilter({
                                    ...filter,
                                    fromPeriod: date
                                      .toISOString()
                                      .split("T")[0],
                                    filterByDay: "",
                                  })
                                }
                                dateFormat="yyyy-MM-dd"
                                maxDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                                placeholderText="Select a date"
                                onFocus={(e) => e.target.blur()}
                              />
                    <Form.Control
                      className="small_form_control"
                      type="text"
                      placeholder="09:00"
                      disabled
                    />
                  </div>
                </div>

                <div className="d-flex align-items-center betting-time-zone">
                  <Form.Label className="pe-3">to</Form.Label>

                  <div className="d-flex align-items-center">
                  <DatePicker
                                className="small_form_control"
                                selected={
                                  filter.toPeriod
                                    ? new Date(filter.toPeriod)
                                    : null
                                }
                                onChange={(date) =>
                                  setFilter({
                                    ...filter,
                                    toPeriod: date.toISOString().split("T")[0],
                                    filterByDay: "",
                                  })
                                }
                                dateFormat="yyyy-MM-dd"
                                minDate={
                                  filter?.fromPeriod
                                    ? new Date(filter?.fromPeriod)
                                        .toISOString()
                                        .split("T")[0]
                                    : new Date()
                                }
                                maxDate={new Date().toISOString().split("T")[0]}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                                placeholderText="Select a date"
                                onFocus={(e) => e.target.blur()}
                              />
                    <Form.Control
                      className="small_form_control"
                      type="text"
                      placeholder="08:59"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </Row>
            <div className="input-list-data">
              <ul className="input-list">
                <li>
                  <a
                    onClick={(e) =>
                      setFilter({
                        ...filter,
                        filterByDay: "today",
                      })
                    }
                    style={{
                      // background: filter.filterByDay === "today" ? "green" : "",
                      cursor: "pointer",
                    }}
                  >
                    Just For Today
                  </a>
                </li>
                <li>
                  <a
                    onClick={(e) =>
                      setFilter({
                        ...filter,
                        filterByDay: "yesterday",
                      })
                    }
                    style={{
                      // background:
                      //   filter.filterByDay === "yesterday" ? "green" : "",
                      cursor: "pointer",
                    }}
                  >
                    From Yesterday
                  </a>
                </li>
                <li>
                  <a
                    onClick={getData}
                    style={{ cursor: "pointer" }}
                    className="btn-send"
                  >
                    Get History
                  </a>
                </li>
                {/* <li>
                  <a
                    onClick={() => {
                      setFilter({
                        betType:
                          title === "Exchange"
                            ? "betfair"
                            : title === "FancyBet"
                            ? "fancy"
                            : title === "Fancy1Bet"
                            ? "sportBook"
                            : title === "BookMaker"
                            ? "bookmaker"
                            : "casino",
                        status: "",
                        toPeriod: "",
                        fromPeriod: "",
                        filterByDay: "",
                      });
                      getData("reset");
                    }}
                    className="btn-send"
                    style={{ cursor: "pointer" }}
                  >
                    Reset
                  </a>
                </li> */}
              </ul>
            </div>
          </Col>
        </Row>
      </Form>

      {data?.length == 0 ? (
        <div id="noReportMessage">
          <p>
            Betting History enables you to review the bets you have placed.{" "}
            <br />
            Specify the time period during which your bets were placed, the type
            of markets on which the bets were placed, and the sport.
          </p>
          <p>Betting History is available online for the past 62 days.</p>
          <p>User can search up to 14 days records per query only .</p>
        </div>
      ) : (
        <>
          <section className="account-table my-bet-sec">
            <div className="profile-tab">
              <div className="my_account_table_wrap">
                <div className="table-main-wrapper">
                  <Table className="table_caption_style">
                    <thead>
                      <tr>
                        {headerDataBetHistory.map((res) => {
                          return (
                            <th
                              scope="col"
                              className={res.class}
                              width={res.widht}
                            >
                              {res.title}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>

                    <tbody>
                      {data && data?.length > 0 ? (
                        data?.map((item) => {
                          return (
                            <>
                              <tr>
                                <td>
                                  <span
                                    style={{
                                      color: "#2789ce",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {active.includes(item?._id) ? (
                                      <img
                                        style={{
                                          height: "15px",
                                          marginRight: "5px",
                                        }}
                                        onClick={() =>
                                          setActive((prev) => {
                                            return prev?.filter((res) => {
                                              return res !== item?._id;
                                            });
                                          })
                                        }
                                        src={require("../../assets/images/expand-open.png")}
                                      />
                                    ) : (
                                      <img
                                        style={{
                                          height: "15px",
                                          marginRight: "5px",
                                        }}
                                        onClick={() =>
                                          setActive((prev) => {
                                            return [...prev, item?._id];
                                          })
                                        }
                                        src={require("../../assets/images/expand-close.png")}
                                      />
                                    )}{" "}
                                    {item?.matchBetId || item?.sessionBetId}
                                  </span>
                                </td>
                                <td>{item?.clientName}</td>
                                <td className="text-start" width="30%">
                                  <span style={{ textTransform: "uppercase" }}>
                                    {obj.betCheckObj[item?.eventType]}
                                  </span>
                                  <img
                                    class="fromto"
                                    src={require("../../assets/images/transparent.gif")}
                                  />
                                  <strong>{item?.matchName}</strong>
                                  <img
                                    class="fromto"
                                    src={require("../../assets/images/transparent.gif")}
                                  />
                                    {item?.betFaireType == 'wifi_bookmaker' ? 'Special BookMaker' :capitalize(item?.betFaireType) ||
                                                               item?.fancyName}
                                </td>
                                <td className="text-end">
                                  {" "}
                                  {filter?.betType === "fancy"
                                    ? item?.runnerName
                                    : filter?.betType === "sportsbook"
                                    ? item?.runnerName
                                    : item?.teamName}
                                </td>
                                <td className="text-end">
                                  {" "}
                                  <span
                                    className={
                                      item?.betType == "lay" ||
                                      item?.type == "No"
                                        ? "lay-bg"
                                        : item?.betType == "back" ||
                                          item?.type == "Yes"
                                        ? "back-bg"
                                        : ""
                                    }
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {item?.betType || item?.type}
                                  </span>
                                </td>
                                <td className="text-end">
                                  {moment(item?.timeInserted).format(
                                    "YYYY-MM-DD hh:mm:ss"
                                  )}
                                </td>
                                {/* <td className="text-end">
                                {" "}
                                {item?.matchBetId || item?.sessionBetId}
                              </td> */}
                                <td className="text-end">
                                  {" "}
                                  {filter.betType === "fancy"
                                    ? item?.betRun + "/" + item?.bhav
                                    : item?.bhav || "N/A"}
                                </td>{" "}
                                <td className="text-end">
                                  {" "}
                                  {item?.amount || "N/A"}
                                </td>
                                <td className="text-end">
                                  {" "}
                                  {filter.betType === "fancy"
                                    ? item?.betRun + "/" + item?.bhav
                                    : item?.bhav || "N/A"}{" "}
                                </td>
                                {filter.betType == "betfair" ||
                                filter.betType == "Bookmaker" ||
                                filter.betType == "toss" ||
                                filter.betType == "tie" ? (
                                  <td className="text-end">
                                    {(item?.teamSelectionWin ==
                                      item?.selectionId &&
                                      item?.betType == "back") ||
                                    (item?.teamSelectionWin !=
                                      item?.selectionId &&
                                      item?.betType == "lay") ? (
                                      <span className="">
                                        {item?.profitAmount}
                                      </span>
                                    ) : (
                                      <span className="text-danger">
                                        ({item?.loseAmount})
                                      </span>
                                    )}
                                  </td>
                                ) : filter.betType === "sportsbook" ? (
                                  <td className="text-end">
                                    {item?.teamSelectionWin &&
                                    item?.teamSelectionWin
                                      .split(",")
                                      .includes(item?.fancySelectionId) ? (
                                      <span className="">
                                        {item?.profitAmount?.toFixed(2)}
                                      </span>
                                    ) : (
                                      <span className="text-danger">
                                        ({item?.loseAmount.toFixed(2)})
                                      </span>
                                    )}
                                  </td>
                                ) : (
                                  <td className="text-end">
                                    {item?.type == "No" ? (
                                      item?.decisionRun < item?.betRun ? (
                                        <span className="">
                                          {item?.profitAmount.toFixed(2)}
                                        </span>
                                      ) : (
                                        <span className="text-danger">
                                          ({item?.loseAmount.toFixed(2)})
                                        </span>
                                      )
                                    ) : item?.decisionRun >= item?.betRun ? (
                                      <span className="">
                                        {item?.profitAmount.toFixed(2)}
                                      </span>
                                    ) : (
                                      <span className="text-danger">
                                        ({item?.loseAmount.toFixed(2)})
                                      </span>
                                    )}
                                  </td>
                                )}
                              </tr>
                              {active.includes(item?._id) && (
                                <tr
                                  className="expand new-bethistory-slip"
                                  id={item?._id}
                                >
                                  <td
                                    style={{ background: "#e2e8ed" }}
                                    colSpan={"2"}
                                  ></td>
                                  <td
                                    colSpan="9"
                                    style={{ background: "#e2e8ed" }}
                                    className="new-bethistory-slip-td"
                                  >
                                    <img
                                      class="expand-arrow"
                                      src={require("../../assets/images/transparent.gif")}
                                    ></img>
                                    <table>
                                      <tbody>
                                        <tr>
                                          <th>Bet Taken</th>
                                          <th>Odds req.</th>
                                          <th>Stake</th>
                                          <th>Liability</th>
                                          <th>Odds Matched</th>
                                        </tr>
                                        <tr
                                          id="txRow0"
                                          style={{ display: "table-row" }}
                                          className="even"
                                        >
                                          <td className="text-end">
                                            {" "}
                                            {moment(item?.timeInserted).format(
                                              "YYYY-MM-DD hh:mm:ss"
                                            )}
                                          </td>
                                          <td className="text-end">
                                            {" "}
                                            {filter.betType === "fancy"
                                              ? item?.betRun + "/" + item?.bhav
                                              : item?.bhav || "N/A"}
                                          </td>{" "}
                                          <td className="text-end">
                                            {" "}
                                            {item?.amount || "N/A"}
                                          </td>
                                          <td className="text-end">
                                            <span className="text-danger">
                                              ({item?.loseAmount.toFixed(2)})
                                            </span>
                                          </td>
                                          <td className="text-end">
                                            {" "}
                                            {filter.betType === "fancy"
                                              ? item?.betRun + "/" + item?.bhav
                                              : item?.bhav || "N/A"}
                                          </td>{" "}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              )}
                            </>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-start">
                            <span>You have no bets in this time period.</span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>

                  {/* <div className="bottom-pagination">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next"
                      forcePage={viewpage}
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={10}
                      pageCount={pageCount}
                      nextLabel="Prev"
                      renderOnZeroPageCount={null}
                      activeClassName="p-1"
                      activeLinkClassName="pagintion-li"
                    />
                  </div> */}
                  {/* <PaginationComp
                  viewpage={viewpage}
                  handlePageClick={handlePageClick}
                  pageCount={pageCount}
                /> */}
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};
export default ExchangeHistory;
